import { ArrowUpRight, BookOpen, Eye, Home, Minus, Sparkles } from "lucide-react";
import { useState } from "react";
import { Link } from "react-router-dom";
import { marketReports, upcomingReportMonths } from "../data/marketReports";

const trendIcons = {
  up: ArrowUpRight,
  stable: Minus,
  watch: Eye,
};

export default function MarketHistory({ onReportChange }) {
  const [activeReport, setActiveReport] = useState(marketReports[0].id);
  const report = marketReports.find((item) => item.id === activeReport) || marketReports[0];
  const handleReportChange = (nextReport) => {
    setActiveReport(nextReport.id);
    onReportChange?.(nextReport);
  };
  return (
    <section className="market-history container" data-testid="market-history-section">
      <div className="section-heading compact-heading">
        <div>
          <p className="eyebrow">Historique des tendances</p>
          <h2>Lire l'évolution,<br />édition après édition.</h2>
        </div>
        <p className="section-intro">Les prochaines analyses seront ajoutées ici, avec le même regard local et qualitatif.</p>
      </div>
      <div className="market-tabs" role="tablist" aria-label="Éditions de l'observatoire" data-testid="market-report-tabs">
        {marketReports.map((item) => <button key={item.id} type="button" role="tab" aria-controls="market-history-panel" aria-selected={item.id === activeReport} className={item.id === activeReport ? "active" : ""} onClick={() => handleReportChange(item)} data-testid={`market-tab-${item.id}`}>{item.shortLabel}<span>{item.status}</span></button>)}
        {upcomingReportMonths.map((month) => <button key={month.id} type="button" role="tab" aria-selected="false" aria-disabled="true" disabled data-testid={`market-tab-${month.id}`}>{month.label}<span>À venir</span></button>)}
      </div>
      <div className="history-edition" id="market-history-panel" role="tabpanel" data-testid="market-history-edition">
        <div className="history-edition-heading"><p className="eyebrow">{report.status}</p><h3>{report.label}</h3><p>Trois signaux éditoriaux à replacer dans votre propre projet immobilier.</p></div>
        <div className="history-signals">{report.sectors.map((sector) => { const Icon = trendIcons[sector.direction]; return <article key={sector.city} data-testid={`history-signal-${sector.city.toLowerCase().replaceAll("'", "").replaceAll(" ", "-")}`}><span className={`trend-icon trend-${sector.direction}`}><Icon size={18} /></span><p>{sector.city}</p><h4>{sector.signal}</h4><span className="trend-label">{sector.trend}</span></article>; })}</div>
      </div>
      <div className="market-edition-actions" data-testid="market-edition-actions">
        <Link to={`/guides/${report.guideSlug}`} data-testid="market-edition-guide-link"><BookOpen size={20} /><span><small>Approfondir le secteur</small><strong>{report.guideTitle}</strong></span><ArrowUpRight size={18} /></Link>
        <Link to={`/biens?city=${encodeURIComponent(report.propertyCity)}`} data-testid="market-edition-properties-link"><Home size={20} /><span><small>Explorer la sélection</small><strong>{report.propertyLabel}</strong></span><ArrowUpRight size={18} /></Link>
        <Link to="/estimation" className="edition-estimate-link" data-testid="market-edition-estimate-link"><Sparkles size={19} /> Demander une estimation</Link>
      </div>
    </section>
  );
}